<!-- Sidebar Wrapper (Detect Mouse Movements) -->
<div 
  class="compacted-side-bar d-flex flex-column justify-content-between h-100"
  (mouseenter)="onCheckLeave($event)">

  <!-- Main Icons Section -->
  <section class="d-flex flex-column align-items-center justify-content-start">
    
    <!-- Sidebar Expand Button -->
    <section class="option my-3 expand-sidebar">
      <morva-icons data-testid="two-caret-left-outline-icon" icon="twoCaretLeftOutline" class="cursor-pointer py-2 my-1" (click)="expandMenu()"></morva-icons>
    </section>

    <!-- Create Button -->
    <section class="option expand-sidebar create-button d-flex flex-column" (click)="expandMenu()">
      <morva-icons 
      [ngClass]="{'disabled-create-item':!(selectedWorkspace?.permissions.get('CreateDashboard').isChecked ||
               selectedWorkspace?.permissions.get('CreateDataSource').isChecked) &&
               (responsiveMode === 'lg' || responsiveMode === 'xl')}" 
        icon="addRectangle"
        class="cursor-pointer my-auto expand-sideba">
      </morva-icons>
    </section>

    <!-- Sidebar Main Items -->
    <div *ngFor="let item of topSideBarMenu">
      <a 
        data-testid="option-item"
        [ngClass]="{ 'option-item': item.havingAccess, 'active': activeLink?.includes(item.link), 'disabled-menu-item': !item.havingAccess}"
        (click)="item.havingAccess && changeRoute(item.link)"
        (mouseenter)="onCheckLeave($event)"> <!-- Global check when hovering other icons -->

        <morva-icons
        [ngClass]="{'icon-24': item.icon === 'bookmark'}"
          [icon]="item.icon"
          class="cursor-pointer"
          (mouseenter)="onHoverIcon(item.icon)"> <!-- Pass the current icon to check if it's a submenu parent -->
        </morva-icons>
      </a>

      <!-- Submenu -->
      <div 
        *ngIf="hoveringSubMenu && currentHoveredItems.length > 0" 
        (mouseenter)="onSubMenuEnter()" 
        (mouseleave)="onLeaveIcon()">
        
        <div class="submenu-wrapper-allcontent">
          <div class="hovered-submenu" *ngIf="currentHoveredMenu === 'allContent'">
            <div class="submenu-arrow"></div>
            <div class="submenu-content">
              <a *ngFor="let subItem of subSideBarAllContentMenu"
                class="submenu-item"
                [ngClass]="{ 'active': activeLink?.includes(subItem.link) && activeTabId === subItem.tabId }"
                (click)="changeRouteWithTab(subItem.link, subItem.tabId)">
                <morva-icons [icon]="subItem.icon"></morva-icons>
                <span>{{ subItem.title }}</span>
              </a>
            </div>
          </div>
        </div>
        
        <!-- Submenu for Bookmarked -->
        <div class="submenu-wrapper-bookmarked">
          <div class="hovered-submenu" *ngIf="currentHoveredMenu === 'bookmarked'">
            <div class="submenu-arrow"></div>
            <div class="submenu-content">
              <a *ngFor="let subItem of subSideBarBookmarkedMenu"
                class="submenu-item"
                [ngClass]="{ 'active': activeLink?.includes(subItem.link) && activeTabId === subItem.tabId }"
                (click)="changeRouteWithTab(subItem.link, subItem.tabId)">
                <morva-icons [icon]="subItem.icon"></morva-icons>
                <span>{{ subItem.title }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>

  <section class="h-100" (click)="expandMenu()"></section>

  <section class="d-flex flex-column align-items-center justify-content-end">
    <a *ngFor="let item of bottomSideBarMenu" [ngClass]="{'option': item.havingAccess, 'active': activeLink?.includes(item.link)}"
    (click)="changeRoute(item.link)">
      <morva-icons *ngIf="item.havingAccess" [icon]="item.icon" class="cursor-pointer"
        [ngClass]="{'icon-24': item.icon === 'bookmark'}"></morva-icons>
    </a>

    <section class="option py-2 my-1 expand-sidebar">
      <morva-icons icon="inbox" class="cursor-pointer" (click)="expandMenu()"></morva-icons>
    </section>
  </section>
</div>
